module.exports = __webpack_public_path__ + "media/images/brand/logo_white-e1ea7d83a6a4e5fba756e6b771401f8f.png";